import {get, post} from '@/utils/http'


/**
 * 获取用户信息
 * @param deviceId {String}
 * @returns {Promise<ResultDTO<FamilyClientConfig>>}
 */
async function getFamilyClientConfig(deviceId) {
    return await get('/family/config/get?deviceId=' + encodeURIComponent(deviceId))
}

/**
 * 注册用户
 * @param config {FamilyClientConfig}
 * @param deviceId {String}
 * @returns {Promise<ResultDTO<>>}
 */
async function doSetFamilyClientConfig({config,deviceId}){
    return await post("/family/config/set?deviceId=" + encodeURIComponent(deviceId), config);
}

export default {
    getFamilyClientConfig,doSetFamilyClientConfig
}
